import React, { useEffect, useState } from 'react';
import { App } from '@capacitor/app';
import styles from './styles.module.scss';

function AppVersion() {
  const [appInfo, setAppInfo] = useState(null);

  useEffect(() => {
    const fetchAppInfo = async () => {
      setAppInfo(await App.getInfo());
    };

    fetchAppInfo();
  }, []);
  return (
    <div className={styles.appVersion}>
      {appInfo && (
        <>
          <div>Version: {appInfo.version}</div>
          <div>Build: {appInfo.build}</div>
        </>
      )}
    </div>
  );
}

export default AppVersion;
